import { isResolvedArrayCellData } from '@doss/common-all'
import { Stack } from '@mui/material'
import { useLookupContext } from '~/components/records/lookup/hooks/LookupProvider'
import { enumSourceForLookupColumn } from '~/components/shared/lookup-enum'
import { DetailedTableLookupColumn, DossTableCell } from '../../tables/types'
import { LookupCellChipV2 } from '../../ui/molecules/lookup-cell-chip/LookupCellChipV2'

interface LookupArrayTableCellProps {
  cell: DossTableCell
  readOnly: boolean
  lookupColumn: DetailedTableLookupColumn
}

/**
 * Renders table cell for a column of type ARRAY with inner type Lookup
 */
export function LookupArrayTableCell({ cell, lookupColumn, readOnly }: LookupArrayTableCellProps) {
  const { getCellDisplay } = useLookupContext()

  if (lookupColumn === null) {
    throw new Error('Lookup column is null')
  }

  let cellValues: Array<string | null> = []
  if (isResolvedArrayCellData(cell.data)) {
    cellValues = cell.data.data.map((value) => (value === null ? null : value.toString()))
  }
  const lookupCells = cell.lookupCells.map((lookupCell, index) => {
    const cellValue = cellValues[index]
    const value =
      cellValue === null
        ? ''
        : (getCellDisplay(
            {
              ...lookupCell,
              userVisibleValue: cellValue,
            },
            lookupColumn.id,
          ) ?? '')
    return {
      value,
      id: lookupCell.id,
      rowId: lookupCell.row.id,
      column: lookupColumn,
      documents: lookupCell.documents,
    }
  })

  const sourceEnum = enumSourceForLookupColumn(lookupColumn)

  return (
    <Stack direction="row" spacing={1}>
      {lookupCells.map((lookupCell) => (
        <LookupCellChipV2
          key={lookupCell.id}
          allowNavigate={!readOnly}
          enumSource={{ column: sourceEnum }}
          lookup={lookupCell}
          type="chip"
        />
      ))}
    </Stack>
  )
}
